export default __webpack_public_path__ + "static/Izzy-ba1dcc68def628cdbf95a25fa74631ae.svg";